// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"WeatherDataContextMenu_toggleButton__7x7VS","menuItem":"WeatherDataContextMenu_menuItem__22BOa","menuItemIcon":"WeatherDataContextMenu_menuItemIcon__Glw2v"};